import fetch from "lib/fetch";
import type { FileInterface } from "types/reference";

type FileListResponse = { data: Array<FileInterface> };

export const getFilesRequest = (languageCode: string) =>
    fetch.get<FileListResponse>(`reference/file/${languageCode}`);
